module.exports = __webpack_public_path__ + "media/icons/bicycle-162e7893.svg";